module.exports = __webpack_public_path__ + "static/media/montenegro-flag.b07a2711.png";